import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { UserTypeEnum } from '@enums/user-type.enum';
import { ApplicationModules } from '@enums/application-modules.enum';

export const MENU_MANAGEMENT: MenuConfigModel = {
  id: ApplicationModules.MANAGEMENT,
  icon: 'manage_accounts',
  name: 'Gestão',
  onlyAssociated: true,
  text: 'Cadastre e organize as <strong>demais configurações</strong> do CFC.',
  profilesToShowItems: [
    UserTypeEnum.ADMINISTRADOR,
    UserTypeEnum.SUPERVISOR
  ],
  submenus: [
    {
      name: 'Comissionamento',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.commissioning}`,
    },
    {
      name: 'Crédito de Matrículas',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.enrollmentCredit}`,
    },
    {
      name: 'Documentos',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.OPERADOR_N1,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.document}`,
    },
    {
      name: 'Documentos Template',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.documentTemplate}`,
    },
    {
      name: 'Estado Civil',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.civilStatus}`,
    },
    {
      name: 'Feriados',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.holiday}`,
    },
    {
      name: 'Horas de Trabalho',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.workingHoursEmployeeRoutingModule}`,
    },
    {
      name: 'Notificações',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.OPERADOR_N1
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.notification}`,
    },
    {
      name: 'Perfis',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.ADMINISTRADOR_DETRAN
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.role}`,
    },
    {
      name: 'Produtos',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.products}`,
    },
    {
      name: 'Sócios',
      onlyAssociated: true,
      profilesToShowItems: [UserTypeEnum.ADMINISTRADOR],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.corporateStructure}`,
    },
    {
      name: 'Tipos de Crédito',
      onlyAssociated: true,
      profilesToShowItems: [UserTypeEnum.ADMINISTRADOR],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.typeCredit}`,
    },
    {
      name: 'Tipos de Contrato de Trabalho',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.employeeContractTypeModule}`,
    },
    // {
    //   name: 'Transparência',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR,
    //   ],
    //   route: `/${ROUTES_APLICATION.management.path}/${ROUTES_APLICATION.management.transparencyPortal}`,
    // },
    {
      name: 'Mensalidade Associativa',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.OPERADOR_N1
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.membershipFee}`,
    }
  ],
}
